export function getQueryStringParameter(name:string, url?:string)
{
	if (!url)
	{
		url = window.location.href;
	}
	name = name.replace(/[\[\]]/g, "\\$&");
	var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
		results = regex.exec(url);
	if (!results) return null;
	if (!results[2]) return '';
	return decodeURIComponent(results[2].replace(/\+/g, " "));
}
export function toCamelCase(str:string) {
	return str.replace(/(?:^\w|[A-Z]|\b\w)/g, (letter, index) => index === 0 ? letter.toLowerCase() : letter.toUpperCase()).replace(/\s+/g, "");
}

export function convertPropertiesToCamelCase(obj: any| Array<any>)
{
	if (obj instanceof Array)
	{
		for (var i = 0; i < obj.length; i++)
		{
			convertObjectToCamelCase(obj[i]);
		}
	}
	return obj;
}

function convertObjectToCamelCase(obj: any)
{
	for (let prop in obj)
	{
		let camelCaseProp = toCamelCase(prop);
		if(camelCaseProp === prop)
			continue;
		obj[camelCaseProp] = obj[prop];
		delete obj[prop];
	}
}
export function fileSizeToString(bytes: number)
{
	const  thresh = 1000;
	if(Math.abs(bytes) < thresh) {
		return bytes + ' B';
	}
	const units = ['kB','MB','GB','TB','PB','EB','ZB','YB'];
	let  u = -1;
	do {
		bytes /= thresh;
		++u;
	} while(Math.abs(bytes) >= thresh && u < units.length - 1);
	return bytes.toFixed(1)+' '+units[u];
}
export function normalizePath(path:string)
{
	if(!path)
		return "";
	return path.replace(/\\/ig,"/");
}
export function getPath(path:string)
{
	if(!path)
		return "";
	return path.substr(0,path.lastIndexOf("/")-1) || "";
}
export function getPathExtension(path:string)
{
	var basename = path.split(/[\\/]/).pop(),
		pos = basename.lastIndexOf(".");

	if (basename === "" || pos < 1)
		return "";
	return basename.slice(pos + 1);
}


// WEBPACK FOOTER //
// ./src/utility/StringUtilities.ts